module.exports = __webpack_public_path__ + "static/img/banner.e6f74821.jpg";